import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";
import ImageText from "../common/imageText";
import ImageHeader from "../common/imageHeader";
import ImageButtonList from "../common/imageButtonList";
import ServiceNavigationBar from "../common/serviceNavigationBar";
import NavigationBar from "../common/navigationBar";
import Popup from "./Popup";

class CareTeamSurvey extends Component {
  QUESTION_LIST = "questionList";
  SERVICE_LIST = "serviceList";
  state = {
    currentList: this.QUESTION_LIST,
    currentRatingIdx: 7,
    textImage: require("./images/survey/1274_1210_elements_questions.png"),
    headerQuestionNum: require("./images/survey/1274_1210_Question1.png"),
    headerImageStyles: {
      unit: "rem",
      top: 1.9,
      left: 60,
    },
    questionImage: require("./images/survey/1274_1210_RateMyCare_question.png"),
    survey: {
      custom_image: require("./images/survey/1274_1210_RatingStar_HL.png"),
      flex: "flex-horizontal",
      answers: [
        {
          id: "1",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 0, click: true }),
        },
        {
          id: "2",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 1, click: true }),
        },
        {
          id: "3",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 2, click: true }),
        },
        {
          id: "4",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 3, click: true }),
        },
        {
          id: "5",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 4, click: true }),
        },
        {
          id: "6",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 5, click: true }),
        },
        {
          id: "7",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 6, click: true }),
        },
        {
          id: "8",
          highlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_HL.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 7, click: true }),
        },
        {
          id: "9",
          highlight: require("./images/survey/1274_1210_RatingStar_UH.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_UH.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 8, click: true }),
        },
        {
          id: "10",
          highlight: require("./images/survey/1274_1210_RatingStar_UH.png"),
          unhighlight: require("./images/survey/1274_1210_RatingStar_UH.png"),
          handleSelect: this.handleOnSelect.bind(this, { id: 9, click: true }),
        },
      ],
    },
    serviceNavigationBar: {
      buttons: [
        {
          id: "exit",
          to: `/care_team/list`,
          highlight: require("./images/survey/1274_1210_btn_exit_HL.png"),
          unhighlight: require("./images/survey/1274_1210_btn_exit_UH.png"),
          disable: require("./images/survey/1274_1210_btn_exit_disabled.png"),
          disabled: false,
          hidden: false,
        },
        {
          id: "previous",
          handleSelect: this.handleQuestionPrevious,
          highlight: require("./images/survey/1274_1210_btn_previous_HL.png"),
          unhighlight: require("./images/survey/1274_1210_btn_previous_UH.png"),
          disable: require("./images/survey/1274_1210_btn_previous_disabled.png"),
          disabled: true,
          hidden: true,
        },
        {
          id: "next",
          handleSelect: this.handleQuestionNext,
          highlight: require("./images/survey/1274_1210_btn_next_HL.png"),
          unhighlight: require("./images/survey/1274_1210_btn_next_UH.png"),
          disable: require("./images/survey/1274_1210_btn_next_disabled.png"),
          disabled: true,
          hidden: false,
        },
        {
          id: "submit",
          to: `/care_team/survey/${this.props.match.params.name}/submit`,
          highlight: require("./images/survey/1274_1210_btn_submit_HL.png"),
          unhighlight: require("./images/survey/1274_1210_btn_submit_UH.png"),
          disable: require("./images/survey/1274_1210_btn_submit_disabled.png"),
          disabled: false,
          hidden: false,
        },
      ],
      default: 2,
    },
    navigationBar: {
      back: true,
      backRoute: `/care_team/details/${this.props.match.params.name}/1`,
      mainMenu: true,
      navigate: true,
    },
  };

  handleOnSelect(argsObj = {}) {
    if (this.state.currentList === this.QUESTION_LIST) {
      if (argsObj.click) {
        this.handleRatingClick(argsObj.id);
      }

      this.setState({
        currentList: this.SERVICE_LIST,
      });
    }
  }

  handleRatingClick(moveToId) {
    const curIdx = this.state.currentRatingIdx;
    if (moveToId > curIdx) {
      const diff = moveToId - curIdx;
      const replaceHighlight = require("./images/survey/1274_1210_RatingStar_HL.png");
      const stateCopy = Object.assign({}, this.state);
      for (let i = 1; i <= diff; i++) {
        stateCopy.survey.answers[curIdx + i].highlight = replaceHighlight;
        stateCopy.survey.answers[curIdx + i].unhighlight = replaceHighlight;
      }
      stateCopy.currentRatingIdx = moveToId;
      this.setState(stateCopy);
    } else if (moveToId < curIdx) {
      const diff = curIdx - moveToId;
      const replaceUnHighlight = require("./images/survey/1274_1210_RatingStar_UH.png");
      const stateCopy = Object.assign({}, this.state);
      for (let i = 0; i < diff; i++) {
        stateCopy.survey.answers[curIdx - i].highlight = replaceUnHighlight;
        stateCopy.survey.answers[curIdx - i].unhighlight = replaceUnHighlight;
      }
      stateCopy.currentRatingIdx = moveToId;
      this.setState(stateCopy);
    }
  }

  handleRatingChange(move) {
    if (this.state.currentList !== this.QUESTION_LIST) return;

    const replaceHighlight = require("./images/survey/1274_1210_RatingStar_HL.png");
    const replaceUnHighlight = require("./images/survey/1274_1210_RatingStar_UH.png");
    if (move > 0) {
      const updateIdx = this.state.currentRatingIdx + move;
      if (updateIdx < this.state.survey.answers.length) {
        const stateCopy = Object.assign({}, this.state);
        stateCopy.survey.answers[updateIdx].highlight = replaceHighlight;
        stateCopy.survey.answers[updateIdx].unhighlight = replaceHighlight;
        stateCopy.currentRatingIdx = updateIdx;
        this.setState(stateCopy);
      }
    } else {
      const updateIdx = this.state.currentRatingIdx;
      if (updateIdx >= 0) {
        const stateCopy = Object.assign({}, this.state);
        stateCopy.survey.answers[updateIdx].highlight = replaceUnHighlight;
        stateCopy.survey.answers[updateIdx].unhighlight = replaceUnHighlight;
        stateCopy.currentRatingIdx = updateIdx + move;
        this.setState(stateCopy);
      }
    }
  }

  toggleCurrentList() {
    const toggle =
      this.state.currentList === this.SERVICE_LIST
        ? this.QUESTION_LIST
        : this.SERVICE_LIST;
    this.setState({
      currentList: toggle,
    });
  }

  handleOnKeyUp(event) {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case "ArrowRight":
        this.handleRatingChange(1);
        break;
      case "ArrowLeft":
        this.handleRatingChange(-1);
        break;
      case "ArrowUp":
        this.toggleCurrentList();
        break;
      case "ArrowDown":
        this.toggleCurrentList();
        break;
      case "Enter":
        this.handleOnSelect();
        break;
      default:
    }
  }

  constructor(props) {
    super(props);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
  }

  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  render() {
    const questionsDisable = this.state.currentList !== this.QUESTION_LIST;
    const questionsUnfocused =
      questionsDisable || !!this.props.match.params.popup;
    const serviceDisable = this.state.currentList !== this.SERVICE_LIST;
    const serviceUnfocused = serviceDisable || !!this.props.match.params.popup;

    return (
      <div className="care-team-survey">
        <ImageHeader
          id="header"
          src={this.state.headerQuestionNum}
          {...this.state.headerImageStyles}
        />
        <ImageText id="text" src={this.state.textImage} />
        <img className="question" src={this.state.questionImage} alt=""></img>
        <ImageButtonList
          id="QuestionList"
          imageButtons={this.state.survey.answers}
          customImage={this.state.survey.custom_image}
          flexClass={this.state.survey.flex}
          unfocused={questionsUnfocused}
          disabled={questionsDisable}
          currentButton={1}
          handleKeyUp={this.handleKeyUp}
        />
        <ServiceNavigationBar
          id="ServiceNavigationBar"
          unfocused={serviceUnfocused}
          disabled={serviceDisable}
          buttons={Array.from(this.state.serviceNavigationBar.buttons)}
          currentButton={this.state.serviceNavigationBar.default}
          handleKeyUp={this.handleOnKeyUp}
        />
        <NavigationBar {...this.state.navigationBar} />
        {this.props.match.params.popup && (
          <Popup popup={this.props.match.params.popup} />
        )}
      </div>
    );
  }
}

const ConnectedCareTeamSurvey = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(CareTeamSurvey);

export default withRouter(ConnectedCareTeamSurvey);
